import { getWalletAddress, getWalletProviderId, hasAuthSession } from '@/utils/auth-token';
import { getSessionLoginType } from '@/utils/user-session-profile';

/**
 * 登录轨 → 资金/签名通道（以本次 originLoginType 为准，见 getSessionLoginType）：
 * - EMAIL / GOOGLE → Privy 托管
 * - WALLET → 当前连接 EOA（登录/SIWE），不依赖 trade-address 绑定
 * 合并账号曾注册 Google 再切钱包登录时，不得因历史 registerType 误入托管轨。
 *
 * 双流动性例外见 usesCustodialExecChannel：WALLET 充值换绑 type=2 后，
 * 下单/授权以 users 托管通道为准（App Signer），与本函数「登录轨」解耦。
 */
export function sessionExpectsCustodialWallet() {
  if (!hasAuthSession()) return false;
  const origin = String(getSessionLoginType() ?? '')
    .trim()
    .toUpperCase();
  if (origin === 'EMAIL' || origin === 'GOOGLE') return true;
  if (origin === 'WALLET') return false;
  if (getWalletProviderId() === 'privy') return true;
  const provider = String(getWalletProviderId() ?? '')
    .trim()
    .toLowerCase();
  if (provider && provider !== 'privy') return false;
  if (String(getWalletAddress() ?? '').trim()) return false;
  return true;
}

export function sessionExpectsSelfCustodyWallet() {
  return hasAuthSession() && !sessionExpectsCustodialWallet();
}

/**
 * 零售下单 / EIP-712 / ensure-ready 是否走托管（App Signer）。
 * - EMAIL/GOOGLE：须 users 已有 type=2
 * - WALLET：换绑 exec Privy（type=2）后同样走托管；未换绑仍走连接中的 EOA
 *
 * @param {{ hasCustodial?: boolean }|null|undefined} capability resolveChainIdentityCapability 结果
 */
export function usesCustodialExecChannel(capability) {
  return Boolean(capability?.hasCustodial);
}
